import React, { Component } from 'react'

class Textarea extends Component {
       
    render() {
        return (
            <div className="nlf-viewer-block nlf-viewer-textarea" dangerouslySetInnerHTML={{__html: this.props.text}}></div>
        )
        
    }
}

export default Textarea


// WEBPACK FOOTER //
// ./src/Textarea.js